import type { FC } from "react";
import type { Company } from "../../api/dto";

const sizes = {
  md: "h-24 w-24 px-2 py-2 rounded",
};

interface CompanyLogoProps {
  /**
   * Display-size, defaults to 'md'.
   */
  size?: keyof typeof sizes;

  /**
   * Company for which to display the logo.
   */
  company: Pick<Company, "logo">;
}
export const CompanyLogo: FC<CompanyLogoProps> = (props) => {
  const sizeStyling = sizes[props.size ?? "md"];
  return (
    <img
      src={`${props.company.logo}`}
      alt=""
      className={`${sizeStyling} bg-white border border-inherit object-contain`}
    />
  );
};
